/**
 * @generated SignedSource<<136562cde08fa79057e72cb806adae5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditPipelinePageQuery$variables = {
  locator: string;
};
export type EditPipelinePageQuery$data = {
  readonly pipeline: {
    readonly " $fragmentSpreads": FragmentRefs<"EditPipelinePageFragment">;
  } | null | undefined;
};
export type EditPipelinePageQuery = {
  response: EditPipelinePageQuery$data;
  variables: EditPipelinePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPipelinePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditPipelinePageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditPipelinePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "headBuildType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "parentProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c5300471c6414be3fe3762d1d1a3518",
    "id": null,
    "metadata": {},
    "name": "EditPipelinePageQuery",
    "operationKind": "query",
    "text": "query EditPipelinePageQuery(\n  $locator: String!\n) {\n  pipeline(pipelineLocator: $locator) {\n    ...EditPipelinePageFragment\n    _id\n  }\n}\n\nfragment ConfigurationStorageCanEditFragment on PipelineRest {\n  parentProject {\n    id\n    _id\n  }\n}\n\nfragment ConfigurationStorageSwitchFragment on PipelineRest {\n  ...ConfigurationStorageCanEditFragment\n  parentProject {\n    name\n    _id\n  }\n}\n\nfragment EditPipelineConfigurationDialogFragment on PipelineRest {\n  ...ConfigurationStorageCanEditFragment\n  ...ConfigurationStorageSwitchFragment\n}\n\nfragment EditPipelinePageFragment on PipelineRest {\n  headBuildType {\n    ...pipelineHeadBuildTypeFragment\n    _id\n  }\n  parentProject {\n    id\n    _id\n  }\n  internalId\n  ...EditPipelineConfigurationDialogFragment\n  ...SettingsSidebarContentFragment\n}\n\nfragment JobSettingsSidebarFragment on BuildTypeRest {\n  ...pipelineHeadBuildTypeFragment\n  ...TimeBadgeFragment\n}\n\nfragment PipelineRepositorySidebarFragment on PipelineRest {\n  parentProject {\n    ...pipelineParentProjectFragment\n    _id\n  }\n  ...ConfigurationStorageSwitchFragment\n}\n\nfragment SettingsSidebarContentFragment on PipelineRest {\n  ...PipelineRepositorySidebarFragment\n  parentProject {\n    ...pipelineParentProjectFragment\n    _id\n  }\n  headBuildType {\n    ...pipelineHeadBuildTypeFragment\n    ...JobSettingsSidebarFragment\n    _id\n  }\n}\n\nfragment TimeBadgeFragment on BuildTypeRest {\n  internalId\n  id\n}\n\nfragment pipelineHeadBuildTypeFragment on BuildTypeRest {\n  id\n}\n\nfragment pipelineParentProjectFragment on ProjectRest {\n  id\n  internalId\n}\n"
  }
};
})();

(node as any).hash = "bfbaf1234e67252c90caa6fce0b486c8";

export default node;
